import { render, staticRenderFns } from "./ManagerSchoolSearch.vue?vue&type=template&id=1122e0eb&scoped=true&"
import script from "./ManagerSchoolSearch.vue?vue&type=script&lang=js&"
export * from "./ManagerSchoolSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1122e0eb",
  null
  
)

export default component.exports